// this file is expected to continue to have zero imports, as it fixes prior circular import issues. adding imports later could break that.
export const shadowBlurRadiusLevel1 = 6
export const actionButtonHeight = 40
export const actionButtonHeightPx = `${actionButtonHeight}px`
export const logoPadding = `24px 32px`
const actionButtonTopBottomMargin = 5
export const actionButtonRightMargin = 10
export const actionButtonDefaultMargin = `${actionButtonTopBottomMargin}px ${actionButtonRightMargin}px ${actionButtonTopBottomMargin}px 0`
